import { RiArrowRightSLine } from '@remixicon/react';
import React, { FC, PropsWithChildren, ReactElement, useState } from 'react';

import ShowSubContext from '../../ShowSubContext';
interface ContextMenuItemProps {
  name: string;
  icon: ReactElement;
  shortcut?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const ContextMenuItem: FC<PropsWithChildren<ContextMenuItemProps>> = ({
  name,
  icon,
  shortcut,
  disabled = false,
  children,
  onClick,
}) => {
  const [showSub, setShowSub] = useState(false);
  return (
    <ShowSubContext.Provider value={{ showSub, setShowSub }}>
      <div
        css={(theme) => ({
          padding: '8px 16px 8px 8px',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          color: theme.colors.content,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.3 : 1,
          ':hover': {
            background: disabled ? undefined : theme.colors.backgroundItem,
            color: theme.colors.content,
          },
        })}
        onClick={() => !disabled && onClick && onClick()}
        onMouseLeave={() => setShowSub(false)}
        onMouseOut={() => setShowSub(false)}
        onMouseOver={() => setShowSub(true)}
      >
        <div
          css={(theme) => ({
            fontSize: 20,
            height: 24,
            display: 'flex',
            alignItems: 'center',
          })}
        >
          {icon}
        </div>
        <div
          css={{
            height: 24,
            marginLeft: 8,
            fontSize: 14,
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            '@media (max-width: 1024px)': {
              fontWeight: 600,
            },
          }}
        >
          {name}
        </div>
        <div
          css={{
            width: 48,
            paddingLeft: 8,
            '@media (max-width: 1024px)': {
              display: 'none',
            },
          }}
        />
        {(children || shortcut) && (
          <div
            css={(theme) => ({
              height: 24,
              lineHeight: '24px',
              fontSize: shortcut ? 12 : 20,
              padding: shortcut ? '0 8px' : 0,
              marginLeft: 8,
              background: shortcut ? theme.colors.pill : undefined,
              borderRadius: 4,
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              '@media (max-width: 1024px)': {
                display: 'none',
              },
            })}
          >
            {shortcut}
            {children && <RiArrowRightSLine size={18} />}
          </div>
        )}
        {showSub && children}
      </div>
    </ShowSubContext.Provider>
  );
};

export default ContextMenuItem;
